<script>
    import helpers from './../../components/Helpers';

    const displayTypes = ['grid', 'list'];
    export default {

        mixins: [helpers],

        props: {
            authCheck: {
                required: true
            },
            resourceId: {
                required: true
            },
            value: {
                default: displayTypes[0],
            },
            image: {
                default: null
            },
            title: {
                require: true
            },
            description: {
                require: true,
            },
            link: {
                require: true
            },
            category: {
                default: false,
            },
            topics: {
                default: false
            },
            cardSizeClass: {
                default: 'col-4'
            },
            slug: {
                default: null,
            },
            resourceShowUri: {
                default: "",
            },
            initialLike: {
                default: false,
            }
        },

        data() {
            return {
                thumbImage: null,
                like: false,
                loading: false
            }
        },

        computed: {
            containerSizeClass() {
                return this.gridType === 'grid'
                    ? this.cardSizeClass
                    : 'col-12';
            },

            gridType: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                },
            },
            readMoreHref() {
                return this.resourceShowUri.replace('SLUG', this.slug);
            },
            cardBody() {
                return this.description.length > 125 ? this.description.substr(0, 125) + "..." : this.description;
            },
            routes() {
                return {
                    like: window.App.routes.api.resources_like,
                    dislike: window.App.routes.api.resources_dislike,
                }
            },
            likeHeartClass() {
                return this.like ? 'fas fa-heart' : 'far fa-heart';
            }
        },

        methods: {
            getCategory() {
                return this.category
                    ? this.category.name
                    : '';
            },
            likeToggle() {
                this.loading = true;
                let callSetting = {
                    method: "post",
                    route: this.routes.like,
                }
                if (this.like) {
                    callSetting.method = "put";
                    callSetting.route = this.routes.dislike;
                }
                axios({
                    method: callSetting.method,
                    url: callSetting.route,
                    data: {
                        resource: this.resourceId
                    }
                }).then((response) => {
                    this.like = !this.like;
                    this.loading = false;
                }).catch(e => console.log(e));
            }
        },

        mounted() {
            this.like = this.initialLike;
        },

        created() {
            this.thumbImage = this.image || this.getFallBackImage();
        }
    }
</script>

<template>
    <div :class="containerSizeClass" v-loading="loading">
        <div class="card" v-if="gridType === 'grid'">

            <div class="card-favorite" v-if="authCheck">
                <a class="active" href="javascript:;" @click="likeToggle"><i :class="likeHeartClass"></i></a>
            </div>

            <img class="card-img-top" :src="thumbImage" alt="Card image cap">


            <div class="card-body">
                <h5 class="card-title">{{ title }}</h5>

                <template v-if="category">
                    <span class="badge badge-primary">{{ getCategory() }}</span>
                </template>

                <template v-if="topics">
					<span v-for="topic in topics" class="badge badge-secondary mr-1">
						{{ topic.name }}
					</span>
                </template>

                <br>
                <div class="card-text">
                    <p v-html="cardBody"></p>
                </div>

                <p class="text-right mb-0">
                    <a :href="readMoreHref" class="link-more">
                        Learn more
                        <i class="icon-arrow-right"></i>
                    </a>
                </p>
            </div>
        </div>
        <div class="card mb-3" v-else>
            <div class="card-body list-view">
                <div class="row">
                    <div class="col-3">
                        <img style="max-width: 200px;" :src="thumbImage" alt="Card image cap">
                    </div>
                    <div class="col">
                        <h5 class="card-title">
                            {{ title }}
                        </h5>

                        <template v-if="category">
                            <span class="badge badge-primary">{{ getCategory() }}</span>
                        </template>

                        <template v-if="topics">
					<span v-for="topic in topics" class="badge badge-secondary">
						{{ topic.name }}
					</span>
                        </template>

                        <br>
                        <p class="card-text" v-html="cardBody"></p>
                        <a :href="readMoreHref" class="link-more">
                            Learn more
                            <i class="icon-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .col-4,
    .col-12 {
        margin-bottom: 20px;
    }

    .card-deck .card {
        margin-left: 0 !important;
        margin-right: 0 !important;
        background: white;
    }

    .card {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/resources/ResourceCard.vue